export default __webpack_public_path__ + "static/Rimini-credit-Sergio-Conti-00c9764589b4b5cefb1ef5084540a99d.jpg";